module.exports = __webpack_public_path__ + "static/media/focus.c8b2c442.jpg";